/**
 * @desc 导入Sku销售预测
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: string,
  params: API.basics.plmProductSku.importSkuForecastExcel.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/importSkuForecastExcel`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
